module.exports = __webpack_public_path__ + "static/media/0_2019_07_03.11aa62a8.jpg";